<template>
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2431.2641148089638!2d1.5625966768826105!3d52.45624404094765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47da1ba93bbb3ca7%3A0xf42fa75e905055ea!2sPILATES%20HAVEN!5e0!3m2!1sen!2suk!4v1722867820441!5m2!1sen!2suk"
    width="100%"
    :height="height"
    style="border:0;"
    allowfullscreen=""
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '450'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/GoogleMapsEmbed.vue